export default function ListIcon({
  width = 14,
  height = 13,
  color = 'currentColor',
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 14 13' fill='none' {...props}>
      <path
        d='M0 1.45833C0 1.84511 0.153645 2.21604 0.427136 2.48953C0.700626 2.76302 1.07156 2.91667 1.45833 2.91667C1.84511 2.91667 2.21604 2.76302 2.48953 2.48953C2.76302 2.21604 2.91667 1.84511 2.91667 1.45833C2.91667 1.07156 2.76302 0.700626 2.48953 0.427136C2.21604 0.153645 1.84511 0 1.45833 0C1.07156 0 0.700626 0.153645 0.427136 0.427136C0.153645 0.700626 0 1.07156 0 1.45833Z'
        fill={color}
      />
      <path
        d='M4.95833 2.04167H13.4167C13.5714 2.04167 13.7197 1.98021 13.8291 1.87081C13.9385 1.76142 14 1.61304 14 1.45833C14 1.30362 13.9385 1.15525 13.8291 1.04585C13.7197 0.936458 13.5714 0.875 13.4167 0.875H4.95833C4.80362 0.875 4.65525 0.936458 4.54585 1.04585C4.43646 1.15525 4.375 1.30362 4.375 1.45833C4.375 1.61304 4.43646 1.76142 4.54585 1.87081C4.65525 1.98021 4.80362 2.04167 4.95833 2.04167Z'
        fill={color}
      />
      <path
        d='M0 6.12533C0 6.5121 0.153645 6.88303 0.427136 7.15652C0.700626 7.43001 1.07156 7.58366 1.45833 7.58366C1.84511 7.58366 2.21604 7.43001 2.48953 7.15652C2.76302 6.88303 2.91667 6.5121 2.91667 6.12533C2.91667 5.73855 2.76302 5.36762 2.48953 5.09413C2.21604 4.82064 1.84511 4.66699 1.45833 4.66699C1.07156 4.66699 0.700626 4.82064 0.427136 5.09413C0.153645 5.36762 0 5.73855 0 6.12533Z'
        fill={color}
      />
      <path
        d='M13.4167 5.54199H4.95833C4.80362 5.54199 4.65525 5.60345 4.54585 5.71285C4.43646 5.82224 4.375 5.97062 4.375 6.12533C4.375 6.28004 4.43646 6.42841 4.54585 6.5378C4.65525 6.6472 4.80362 6.70866 4.95833 6.70866H13.4167C13.5714 6.70866 13.7197 6.6472 13.8291 6.5378C13.9385 6.42841 14 6.28004 14 6.12533C14 5.97062 13.9385 5.82224 13.8291 5.71285C13.7197 5.60345 13.5714 5.54199 13.4167 5.54199Z'
        fill={color}
      />
      <path
        d='M0 10.7913C0 11.1781 0.153645 11.549 0.427136 11.8225C0.700626 12.096 1.07156 12.2497 1.45833 12.2497C1.84511 12.2497 2.21604 12.096 2.48953 11.8225C2.76302 11.549 2.91667 11.1781 2.91667 10.7913C2.91667 10.4046 2.76302 10.0336 2.48953 9.76014C2.21604 9.48665 1.84511 9.33301 1.45833 9.33301C1.07156 9.33301 0.700626 9.48665 0.427136 9.76014C0.153645 10.0336 0 10.4046 0 10.7913Z'
        fill={color}
      />
      <path
        d='M13.4167 10.208H4.95833C4.80362 10.208 4.65525 10.2695 4.54585 10.3789C4.43646 10.4883 4.375 10.6366 4.375 10.7913C4.375 10.9461 4.43646 11.0944 4.54585 11.2038C4.65525 11.3132 4.80362 11.3747 4.95833 11.3747H13.4167C13.5714 11.3747 13.7197 11.3132 13.8291 11.2038C13.9385 11.0944 14 10.9461 14 10.7913C14 10.6366 13.9385 10.4883 13.8291 10.3789C13.7197 10.2695 13.5714 10.208 13.4167 10.208Z'
        fill={color}
      />
    </svg>
  );
}
